import { css, styled } from '@mui/material/styles';
import { Tabs } from '@mui/material';
const selectedBullet = ({ theme, $bullets }) =>
  $bullets &&
  css`
    background-color: ${theme.DS_palette.background.light};
    border-radius: ${theme.DS_border.radius.priceCard};
    button {
      min-width: unset;
    }
    button.Mui-selected {
      div {
        outline: 10px solid ${theme.DS_palette.buttons.stroke};
      }
    }
  `;

export const StyledTabs = styled(Tabs)`
  .MuiTabs-flexContainer {
    justify-content: space-between;
    margin: 0 20px;
    ${selectedBullet};
  }

  > div > .MuiTabs-indicator {
    display: none;
  }

  &.scrollable {
    margin: 0 20px;
    svg {
      width: 0.7em;
      height: 0.7em;
      path {
        fill: #bbbbbb;
      }
    }
  }
`;

export const Bullets = styled('div')(
  ({ theme }) => `
  background-color: ${theme.DS_palette.buttons.enabled};
  width: 14px;
  height: 14px;
  border-radius: 100%;
`,
);

export const StyleTabPanel = styled('div')(
  () => `

  transition: 0.5s transform ease-in-out;
  &.disappear {
    transform: translateX(120%);
  }
  &.appear {
   transform: translateX(0);
  }

`,
);

export const StyledTabImageLabel = styled('div')(
  ({ theme }) => `
    margin-right: ${theme.DS_spacing(['xl'])};
    .gatsby-image-wrapper  {
       > div {
        width: 100%;
        max-width: 180px !important;
        height: 50px;
    }
        
    img {
      object-fit: contain !important; 
      }
    }
         
    ${theme.breakpoints.up('lg')} {
        .gatsby-image-wrapper  > div {
          max-width: 300px !important;
       }
    }

`,
);
